// extracted by mini-css-extract-plugin
export default {"icon":"VSghg3qY32BvdDny8bkX","inner":"Ybw8e9m7paGAvls_NO2L"};